import styled from "styled-components/macro";
import { Chip } from "@mui/material";

const StatusChip = styled(Chip)`
  height: 20px;
  padding: 4px 0;
  font-size: 90%;
  background-color: ${(props) =>
    props.theme.palette[
      props.options[props.value] ? props.options[props.value].color : "primary"
    ].light};
  color: ${(props) => props.theme.palette.common.white};
`;

export default StatusChip;
